interface StageBadgeProps {
  name?: string | null
  category?: string | null
  className?: string
}

const CATEGORY_CLASS: Record<string, string> = {
  committed: 'badge badge--stage badge--stage-committed',
  open_pipeline: 'badge badge--stage badge--stage-pipeline',
  lost: 'badge badge--stage badge--stage-lost',
}

export function StageBadge({ name, category, className = '' }: StageBadgeProps) {
  const label = name?.trim() || 'Unknown stage'
  const cat = (category ?? '').toLowerCase()
  const tone = CATEGORY_CLASS[cat] ?? 'badge badge--stage'
  return <span className={`${tone} ${className}`.trim()}>{label}</span>
}
